<template id="drilldown-report-page">
  <section>
    <div class="row">
      <div class="card-section">
        <div class="card" :class="this.$store.state.bannerStatus ? 'banner-true' : 'banner-false'">
          <div class="card-header d-flex flex-column" style="padding: 5px 10px;">

            <!-- 🔹 Top row -->
            <div class="d-flex justify-content-between align-items-center w-100">
              <strong>
                <i v-if="$store.state.deviceType==='Mobile'"
                   :class="repTitle? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
                   ref="tooltipIcon"
                   v-b-tooltip.hover.right.html="{ title: repTitle, customClass: 'my-custom-tooltip', autoHide: false }"
                   @mouseenter="showTooltip"
                   @mouseleave="hideTooltip">
                </i>
                <i  v-if="$store.state.deviceType !== 'Mobile'"
                    :class="screenTitleInfo? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
                   ref="tooltipIcon"
                   v-b-tooltip.hover.right.html="{ title: screenTitleInfo, customClass: 'my-custom-tooltip', autoHide: false }"
                   @mouseenter="showTooltip"
                   @mouseleave="hideTooltip">
                </i>
                <span v-if="$store.state.deviceType !== 'Mobile'" class="ml-1">{{ repTitle }}</span>
              </strong>

              <div v-if="checkboxFlag[1] && $store.state.deviceType==='Mobile'">
      <span @click="assignBox(selectedRows)">
        <i class="fa fa-user-cog text-info" style="padding:5px"></i>
      </span>
              </div>

              <div class="d-flex align-items-center">
                 <span style="color:steelblue" v-if="checkboxFlag[1] && selectedRows.length>0 && $store.state.deviceType!=='Mobile'">
                {{
                     selectedRows.length
                   }} selected out of {{
                     selectableCount !== null ? selectableCount + ' editable (' + filteredItems.length + ' total)' : filteredItems.length + ' total'
                   }}
              </span>
                <div class="flex-grow-0" style="min-width: 200px; max-width: 300px; margin-left: 10px;">
                  <div class="input-group">
                    <input type="text"
                           v-model="filterValue"
                           placeholder="Search on Display..."
                           class="form-control form-control-sm">
                  </div>
                </div>

                <div v-if="$store.state.deviceType==='Mobile'" style="margin-left: 5px">
                  <button @click="showFilterDialog" class="btn btn-sm"
                          v-bind:class="{'btn-primary': filterIsSelected, 'btn-info': !filterIsSelected}">
                    <span style="font-size: .7rem"><i class="fas fa-filter"></i></span>
                    <span class="ml-1" v-if="!filterIsSelected">Filter</span>
                    <span class="ml-1" v-else>{{ filterCount }}</span>
                  </button>
                </div>

                <span v-for="(ai,index) in currentRepActionIconsData" :key="index">
        <download-csv v-if="ai.actionIconsName=== 'download'" class="btn btn-default" :data="cleanedDownload"
                      :name="momentAll" v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
          <i v-bind:id="ai.iconId" v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
             :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
             style="font-size:15px; float: right; margin-top: -3px; ">
          </i>
        </download-csv>

        <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
          <i v-if="ai.actionIconsName!== 'download'" v-bind:id="ai.iconId"
             v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
             :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
             style="font-size:15px; padding-left:10px;">
          </i>
        </span>
      </span>
              </div>
            </div>

            <!-- 🔹 Bottom row (Mobile selection text) -->
            <div v-if="checkboxFlag[1] && selectedRows.length>0 && $store.state.deviceType==='Mobile'" class="mt-1">
    <span style="color:steelblue">
      {{ selectedRows.length }} selected out of {{
        selectableCount !== null ? selectableCount + ' editable (' + filteredItems.length + ' total)' : filteredItems.length + ' total'
      }}
    </span>
            </div>

          </div>

          <div class="card-body">
            <b-overlay :show="spinner">
              <div class="table-responsive" :aria-hidden="spinner ? 'true' : null">
                <div v-if="$store.state.deviceType!=='Mobile'" class="d-flex flex-wrap my-2 card-body-header">
                  <div v-if="checkboxFlag[1]">
                      <span @click="assignBox(selectedRows)">
                         <i class="fa fa-user-cog text-info" style="padding:5px"></i>
                       </span>
                  </div>

                  <div class="mx-1" v-show="dimSelectDpValuesPl.length==0" v-for="(key,index) in dimSelectDpValues"
                       :key="index">
                    <span>{{ key }}:</span>
                    <multiselect
                        v-model="filter[rowsDataDimKeys[index]]"
                        :options="listBoxOptions[rowsDataDimKeys[index]] || []"
                        :multiple="true"
                        select-label="Select"
                        deselect-label="Unselect"
                        :limit="1"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        @input="optionSelected(filter)"
                    >
                    </multiselect>
                  </div>
                  <div class="mx-1" v-for="(key,index) in dimSelectDpValuesPl" :key="index">
                    <span>{{ key }}:</span>
                    <multiselect
                        v-model="filterPl[rowsDataDimKeysPl[index]]"
                        :options="listBoxOptionsPl[rowsDataDimKeysPl[index]] || []"
                        :multiple="true"
                        select-label="Select"
                        deselect-label="Unselect"
                        :limit="1"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        @input="optionSelectedPl(filterPl)"
                    >
                    </multiselect>
                  </div>

                  <div class="mx-1" v-for="(key,index) in dimInputDpValuesPl" :key="key">
                    <span style="color: blue">{{ key }}:</span>
                    <textarea
                        :value="displayValues[rowsDataDimKeysInpPl[index]] || ''"
                        @input="updateDisplayValue(rowsDataDimKeysInpPl[index], $event.target.value)"
                        @blur="processFilterValues(rowsDataDimKeysInpPl[index])"
                        placeholder="Search on Database.."
                        class="form-control form-control-sm mb-2 blue-placeholder"
                        rows="1"
                        style="resize: vertical; color: #5c9aff;">
                    </textarea>
                  </div>
                  <!--                  <div class="p-1 d-flex flex-column">-->
                  <!--                    <span>Generic Search</span>-->
                  <!--                    <input type="text" v-model="filterValue" placeholder="Search">-->
                  <!--                  </div>-->
                  <div class="mt-3 mr-auto p-1">
                    <button id="button" class="ml-1 btn-sm btn-warning" @click="submitPl"> Submit</button>
                    <button id="button" style="margin-left: -5px" class="m-1 btn-sm btn-outline-danger"
                            @click="resetLBPl"> Reset
                    </button>
                  </div>
                </div>

                <div class="grid-container" :style="{ height: gridContainerHeight }">
                  <table v-show="showTable" class="table table-bordered table-hover">
                    <thead class="thead-dark" align="center">
                    <tr>
                      <th class='grid-item--header-one' v-if="checkboxFlag[1]">
                        <input type="checkbox" v-model="isAllSelected" @click="selectAll">
                      </th>
                      <th v-else>Action</th>
                      <th v-if="drilldownlevels.length>1"></th>
                      <th :class="index==0?'':''" v-for="(col,index) in headerColumns[1]" v-bind:key="col">
                        {{ col }}
                        <a href="#" @click="sortBy(Rcolumns[index])">
                          <i class="fa"
                             v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' "
                             v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]">
                          </i>
                        </a>
                      </th>
                      <th>Assign</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(rowd,idx) of filteredItems ">
                      <tr v-bind:style="whatL1===rowd['rd1l1_name']?'background-color:#63BFF8':''"
                          v-bind:key="idx" :class="getClass(`${rowd['rd6']}`)">
                        <td class='grid-col--fixed-left' v-if="checkboxFlag[1]">
                          <input type="checkbox" v-model="selectedRows" :value="rowd.rd1l1_name"
                                 :disabled="rowd['user_editable']===false"
                                 :title="rowd['user_editable'] === false ? 'Selection not allowed' : ''"
                                 :class="{ 'disabled-checkbox': rowd['user_editable'] === false }"
                          >
                        </td>
                        <td v-else>
                            <span @click="assignBox([rowd['rd1l1_name']])">
                              <i class="fa fa-user-cog text-info" v-bind:style="whatL1===rowd['rd1l1_name']?'background-color:white;padding:4px;border:2px;border-radius:10px':''"></i>
                            </span>
                        </td>
                        <td v-if="drilldownlevels.length>1">
                          <span @click="toggleL1(rowd)">
                            <span class="offset-md-0" style="cursor: pointer">
                              {{ isExpandedL1(rowd) ? '-' : '+' }}
                            </span>
                          </span>
                        </td>
                        <td :class="index==0?'': col.startsWith('rm')?'text-right':''"
                            v-for="(col,index) in Rcolumns"
                            v-bind:key="col">
                          <!-- Check if the cell value is a URL/hyperlink -->
                          <span v-if="col.toLowerCase().startsWith('hyperlink') && rowd[col]">
                            <a :href="rowd[col]" target="_blank" class="text-primary text-decoration-underline"  v-html="hyperlinkConfig">
                            </a>
                          </span>
                          <span v-else>
                            {{ rowd[col] }}
                          </span>
                        </td>
                        <td>
                          <span v-if="rowd.assign==null">- NA -</span>
                          <span v-if="rowd.assign!=null">{{ rowd.assign }}</span>
                        </td>
                      </tr>
                      <tr v-if="isExpandedL1(rowd) && firstDrilldownData.length > 0 && headerLvl2Display==='true'"
                          class="table-info" v-bind:key="`c-${idx}`">
                        <th></th>
                        <template v-for="col in headerColumns[2]">
                          <th v-bind:key="col"><span class="offset-md-1"> {{ col }} </span></th>
                        </template>
                        <!--                          <th>Action</th>-->
                        <th>Assign</th>
                      </tr>
                      <template v-for="(first,idx) of firstDrilldownData">
                        <tr v-bind:key="`first-${idx}`"
                            v-if="isExpandedL1(rowd)" style="background-color: #8FD1FA">
                          <td>
                            <a @click="toggleL2(rowd, first)">
                              <span class="offset-md-1" style="cursor: pointer">
                                {{ isExpandedL2(first) ? 'v' : '>' }} <!-- toggle symbol -->
                              </span>
                            </a>
                          </td>
                          <td :class="{'text-right' : col2.startsWith('rm')}" v-for="col2 in R2columns"
                              v-bind:key="col2">
                            <span class="offset-md-1">
                              {{ col2 === 'n' ? headerColumns[2][1] : first[col2] }}
                            </span>
                          </td>
                          <!--                            <td>
                                                        &lt;!&ndash;                          <span @click="commentBox(first['rd1_id'])">
                                                                                          <i class="fa fa-lg fa-comments text-primary"></i>
                                                                                      </span>
                                                                                <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                                                          <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                                                      </span>
                                                                                <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                                              <i class="fa fa-user-cog text-info"></i>
                                                                                          </span>
                                                                                <span @click="accept(rowd['rd1l1_name'])" title="Accept">
                                                                                          <i class="fas fa-thumbs-up"></i>
                                                                                        </span>
                                                                                <span @click="reject(rowd['rd1l1_name'])" title="Reject">
                                                                                          <i class="fas fa-thumbs-down"></i>
                                                                                        </span>&ndash;&gt;
                                                        <span v-for="(ai,index) in currentMenuActionIconsData[2]" :key="index">
                                                          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index,rowd['rd1l1_name'])">
                                                            <i v-bind:id="ai.iconId"
                                                              v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                                                              :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                                                              style="font-size:15px; padding-left:10px; color:skyblue">
                                                            </i>
                                                          </span>
                                                        </span>
                                                        &lt;!&ndash;                                  <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">&ndash;&gt;
                                                        &lt;!&ndash;                                    <i class="fa fa-download text-info"></i>&ndash;&gt;
                                                        &lt;!&ndash;                                  </a></td>&ndash;&gt;
                                                      </td>-->
                          <td v-b-tooltip.hover title="Assign">
                            <span data-ng-if="rowd.assign==null">- NA -</span>
                            <span data-ng-if="rowd.assign!=null">{{ rowd.assign }}</span>
                          </td>
                        </tr>
                        <tr v v-if="isExpandedL1(rowd) && isExpandedL2(first) && headerLvl3Display==='true'"
                            class="table-primary"
                            v-bind:key="`second-${idx}`">
                          <th></th>

                          <template v-for="col in headerColumns[3]">
                            <th v-bind:key="col"><span class="offset-md-2"> {{ col }} </span></th>
                          </template>
                          <!--                            <th>Action</th>-->
                          <th>Assign</th>
                        </tr>
                        <template v-for="(snd,idx) of secondDrilldownData">
                          <tr v-bind:key="`second2-${idx}`" style="background-color: #E7F5FE"
                              v-if="whatL1 === (submenuParam1==='G01' ? rowd.rd1l1_id : rowd.rd1l1_name) && whatL2 === (first.rd1l2_name ? first.rd1l2_name:false) && secondDrilldownData.length>0">


                            <td><span class="offset-md-2">&#8680;</span></td>
                            <td :class="{'text-right' : col3.startsWith('rm')}" v-for="col3 in R3columns"
                                v-bind:key="col3">
                              <span class="offset-md-1">
                                {{ col3 === 'n' ? headerColumns[3][1] : snd[col3] }}
                              </span>
                            </td>

                            <!--                              <td>
                                                          &lt;!&ndash;
                                                                                      <span @click="commentBox(snd['rd1_id'])">
                                                                                                  <i class="fa fa-lg fa-comments text-primary"></i>
                                                                                              </span>
                                                                                      <span @click="tagBox('Retailer Drilldown', 'drilldown_report')">
                                                                                                  <i class="fa fa-tags text-primary" style="padding:5px"></i>
                                                                                              </span>
                                                                                      <span @click="assignBox('retailer_view', p.retailer_id)">
                                                                                                      <i class="fa fa-user-cog text-info" style="padding:5px"></i>
                                                                                                  </span>
                                                          &ndash;&gt;
                                                            <span v-for="(ai,index) in currentMenuActionIconsData[3]" :key="index">
                                                              <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
                                                                <i v-bind:id="ai.iconId"
                                                                   v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                                                                   :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                                                                    style="font-size:15px; padding-left:10px; color:skyblue">
                                                                </i>
                                                              </span>
                                                            </span>

                                                            &lt;!&ndash;                                      <a :href="downloadFile(rowd['rd1l2_name'])" target="_blank">&ndash;&gt;
                                                            &lt;!&ndash;                                        <i class="fa fa-download text-info"></i>&ndash;&gt;
                                                            &lt;!&ndash;                                      </a>&ndash;&gt;
                                                          </td>-->
                            <td>
                              <span data-ng-if="rowd.assign==null">- NA -</span>
                              <span data-ng-if="rowd.assign!=null">{{ rowd.assign }}</span>
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                    <!-- <tr v-for ="header in headerColumns" v-bind:key="header" >
                    <td v-for="col in header" v-bind:key="col"> {{col }}</td>
                    <td> {{header}}</td></tr>-->
                    </tbody>
                  </table>
                </div>
                <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
                  <b-form-group label="Comment">
                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                  </b-form-group>
                </b-modal>

                <b-modal ref="tag-box" @ok="postTagging()" :title="tagTitle">
                  <b-form-group label="Tagging">
                    <!--
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
                                      <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate
                    -->
                    <!--                  <span v-if="iconsConfig.tag_type=='radio'">
                                      <span  v-for="v in iconsConfig.tagList" :key="v">
                                      <input  type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list" v-model="picked"> {{v.tag_list}}
                                      </span>
                                      </span>

                                      <span v-if="iconsConfig.tag_type=='checkbox'">
                                      <span  v-for="v in iconsConfig.tagList" :key="v">
                                      <input  type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{v.tag_list}}
                                      </span>
                                      </span>-->

                    <v-select v-if="iconsConfig.tag_type=='dropdown'" multiple v-model="selected"
                              :options="this.iconsConfig['tagList'].map(k=>k['tag_list'])"
                              :close-on-select="false"></v-select>

                  </b-form-group>

                  <b-form-group label="Comment">
                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                  </b-form-group>
                </b-modal>

                <b-modal v-if="currentMenuActionIconsData.length>0" ref="assign-box" @ok="postAssign()"
                         :title="tagTitle">

                  <b-form-group v-for="(icon,index) in iconsConfig" :key="index"
                                :label="icon.is_group_action=='yes'?'':icon.name" label-class="font-weight-bold">
<span v-if="icon.is_group_action=='yes'">
                  <b-form-group v-for="(gicon,index) in actionLevels" :key="index"
                                :label="filteredConfig[0][gicon+'_field_name']" label-class="font-weight-bold">

                    <span v-if="filteredConfig[0][gicon+'_input_type']==='radio'">
<!--                      {{actionOptions[gicon+'_value']}}-->
                  <span v-for="(v,index) in actionOptions[gicon+'_value']" :key="index">
                  <input @input="appendCurLevel(gicon)" type="radio" :name="gicon+'radioOptions'" :id="gicon+'radio'"
                         :value="v" v-model="selectConfigVal[gicon+'_value']"> {{ v }}
                  </span>
                  </span>

                  <span v-if="filteredConfig[0][gicon+'_input_type']==='checkbox'">
                  <span v-for="(v,index) in actionOptions[gicon+'_value']" :key="index">
                  <input @input="appendCurLevel(gicon,'checkbox',$event)" type="checkbox" :id="index" :value="v"
                         v-model="checkboxSelected"> {{ v }}
                  </span>
                    <!--                    Selected : {{checkboxSelected}}-->
                    <!--                    Selected : {{selectConfigVal[gicon+'_value']}}-->
                  </span>
                  <span>

                  <v-select @input="appendCurLevel(gicon)" v-if="filteredConfig[0][gicon+'_input_type']==='dropdown'"
                            v-model="selectConfigVal[gicon+'_value']"
                            :options="actionOptions[gicon+'_value']"
                            :close-on-select="true"></v-select>
                  </span>
                  <input v-if="filteredConfig[0][gicon+'_input_type']==='datepicker'" type="date" name="inlineDatefield"
                         v-model="selectConfigVal[gicon+'_value']">

                    <input v-if="filteredConfig[0][gicon+'_input_type']==='number_input'" type="number"
                           name="numericField" id="numeric" v-model="selectConfigVal[gicon+'_value']">
                    <input v-if="filteredConfig[0][gicon+'_input_type']==='text_input'" type="text" name="textField"
                           id="text" v-model="selectConfigVal[gicon+'_value']">


                  </b-form-group>
</span>
                    <span v-else>

                     <input v-if="icon.action_type==='number_input'" type="number" name="numericField" id="numeric"
                            v-model="icon.value">
                    <input v-if="icon.action_type==='text_input'" type="text" name="textField" id="text"
                           v-model="icon.value">

                    <textarea v-if="icon.action_type==='textarea'" rows="3" cols="40" v-model="icon.value"
                              placeholder="Write a comment..."></textarea>

                  <span v-if="icon.action_type==='radio'">
                  <span v-for="(v,index) in icon.tagList" :key="index">
                  <input type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list"
                         v-model="icon.value"> {{ v.tag_list }}
                  </span>
                  </span>

                  <span v-if="icon.action_type==='checkbox'">
                  <span v-for="(v,index) in icon.tagList" :key="index">
                  <input type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{ v.tag_list }}
                  </span>
                  </span>
                  <span>
                  <v-select v-if="icon.action_type==='dropdown'" v-model="icon.value"
                            :options="icon['tagList'].map(k=>k['tag_list'])"
                            :close-on-select="true"></v-select>
                  </span>
                  <input v-if="icon.action_type==='datepicker'" type="date" name="inlineCheckbox" v-model="icon.value">
                  </span>


                    <!--                  <select v-if="icon.action_type=='" v-model="assigned" >
                                        <option v-for="(v,index) in iconsConfig.tagList" :key="index" :value="v.tag_list"> {{v.tag_list}}</option>
                                      </select>-->

                  </b-form-group>
                  <button @click="resetActionOptions" name="Reset">Reset</button>
                  <!--                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='tagBox' ).length>0" label="Tagging">
                                      &lt;!&ndash;
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="OnTrack" v-model="picked"> OnTrack
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="RedFlag" v-model="picked"> RedFlag
                                                        <input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Validate" v-model="picked"> Validate
                                      &ndash;&gt;
                                      <span v-if="iconsConfig.tag_type=='radio'">
                                    <span  v-for="(v,index) in iconsConfig.tagList" :key="index">
                                    <input  type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="v.tag_list" v-model="picked"> {{v.tag_list}}
                                    </span>
                                    </span>

                                      <span v-if="iconsConfig.tag_type=='checkbox'">
                                    <span  v-for="(v,index) in iconsConfig.tagList" :key="index">
                                    <input  type="checkbox" name="inlineCheckbox" :value="v" v-model="v.value"> {{v.tag_list}}
                                    </span>
                                    </span>

                                      <v-select v-if="iconsConfig.tag_type=='dropdown'" multiple v-model="selected"
                                                :options="this.iconsConfig['tagList'].map(k=>k['tag_list'])"
                                                :close-on-select="false"></v-select>
                                    </b-form-group>
                                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='assignBox' ).length>0" label="Assign">
                                      <select v-model="assigned" >
                                      &lt;!&ndash;<option value="Andy">Andy</option>
                                      <option value="Sarah">Sarah</option>
                                      <option value="Roger">Roger</option>
                                      <option value="Mark">Mark</option>
                                      <option value="Kane">Kane</option> &ndash;&gt;
                                      <option v-for="ov in userData" :key="ov.userName" :value="ov.firstName"> {{ov.firstName}}</option>
                                    </select>
                                  </b-form-group>
                                  <b-form-group v-if="currentMenuActionIconsData[1].filter(f=>f.functionName==='commentBox' ).length>0" label="Comment">
                                    <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
                                  </b-form-group>-->
                </b-modal>
                <b-modal ref="accept-box" @ok="loadReportlevel1()" title="Accept Dialog">
                  <b-form-group label="Accept">
                    <p> Merge the Customer</p>
                  </b-form-group>
                </b-modal>
                <b-modal ref="reject-box" @ok="loadReportlevel1()" title="Reject Dialog">
                  <b-form-group label="Reject">
                    <p> Reject the matching Customer and keep it separate</p>
                  </b-form-group>
                </b-modal>
                <b-modal ref="error-box" title="Oops! Something went wrong!">
                  <p>Please check your row selection/checkbox.<br/>
                    Min one row should be selected. Max 500 can be updated at once.</p>
                </b-modal>

              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <dialog ref="dialog">
      <input ref="hiddenInput" type="text" style="position: absolute; opacity: 0;width: 0">
      <div class="d-flex flex-column h-100">
        <button @click="hideFilterDialog" class="btn btn-outline"
                style="position: absolute; right: 10px; top: 30px;font-size: small; background-color: white">
          X
        </button>
        <h5 class="text-left mb-2 pb-2" style="border-bottom: 1px solid #ccc">Filters for {{ repTitle }}</h5>
        <div>
          <common-alert
              :is-visible="showAlert"
              :dismiss-secs="7"
              message="This Menu Requires a Pre Selection Filter,Please Choose."
              variant="warning"
              @dismissed="onAlertDismissed"
          />
        </div>
        <div class="flex-grow-1 mb-3" style="overflow-y: auto; overflow-x: hidden">
          <div class="row">
            <div v-show="dimSelectDpValuesPl.length==0" v-for="(key,index) in dimSelectDpValues"
                 :key="index" class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
              <span class="text-left" style="font-size: .8rem; font-weight: bold">{{ key }}:</span>
              <multiselect
                  v-model="filter[rowsDataDimKeys[index]]"
                  :options="listBoxOptions[rowsDataDimKeys[index]] || []"
                  :multiple="true"
                  select-label="Select"
                  deselect-label="Unselect"
                  :limit="1"
                  :clear-on-select="false"
                  :preserve-search="true"
                  @input="optionSelected(filter)"
              >
              </multiselect>
            </div>
            <div v-for="(key,index) in dimSelectDpValuesPl" :key="index"
                 class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
              <span>{{ key }}:</span>
              <multiselect
                  v-model="filterPl[rowsDataDimKeysPl[index]]"
                  :options="listBoxOptionsPl[rowsDataDimKeysPl[index]] || []"
                  :multiple="true"
                  select-label="Select"
                  deselect-label="Unselect"
                  :limit="1"
                  :clear-on-select="false"
                  :preserve-search="true"
                  @input="optionSelectedPl(filterPl)"
              >
              </multiselect>
            </div>

            <div class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column" v-for="(key,index) in dimInputDpValuesPl"
                 :key="key">
              <span style="color: blue">{{ key }}:</span>
              <textarea
                  :value="displayValues[rowsDataDimKeysInpPl[index]] || ''"
                  @input="updateDisplayValue(rowsDataDimKeysInpPl[index], $event.target.value)"
                  @blur="processFilterValues(rowsDataDimKeysInpPl[index])"
                  placeholder="Search on Database.."
                  class="form-control form-control-sm mb-2 blue-placeholder"
                  rows="1"
                  style="resize: vertical; color: #5c9aff;"
              >
            </textarea>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button id="button" class="btn-sm btn-success"
                  @click="submitPl"> Submit
          </button>
          <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetLBPl" title="Reset"
                  style="background-color: transparent;">
            Reset <i class="fas fa-times-circle"></i>
          </button>
        </div>
      </div>
    </dialog>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment";
import Multiselect from 'vue-multiselect/src/Multiselect'
import debounce from 'lodash.debounce';
import CommonAlert from "@/components/CommonAlert.vue";
import {apiAbort} from "@/common/apiAbort";

export default {
  name: 'drilldown-report-page',
  props: {
    viz1: Object,
  },
  components: { CommonAlert, Multiselect},
  data: function () {
    return {
      title:'',
      spinner: false,
      file: '',
      output: [],
      currentMenuActionIconsData: [],
      currentRepActionIconsData: {},
      levelicons: [],
      iconOnChangeFlag: [],
      repTitle: '',
      keys: [],
      customerData: [],
      submenuParam1: null,
      firstDrilldownData: [],
      secondDrilldownData: [],
      cleanedDownload: [],
      reportDataConfig: {},
      retid: [],
      levels: [],
      whatLA: [],
      whatL1: null,
      whatL2: null,
      level1: [],
      level2: [],
      levelId: 1,
      repDataDp: [],
      rowsdata: [],
      icons: [],
      iconsConfig: {},
      levelColumns: [],
      headerColumns: [],
      checkboxFlag: [],
      checkboxSelected: [],
      funCallParamArr: [],
      clickSymbolArr: [],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      dimSelectDpValuesPl: [],
      dimInputDpValuesPl: [],
      rowsDataDimKeys: [],
      rowsDataDimKeysPl: [],
      rowsDataDimKeysInpPl: [],
      levelKeys: ['level1_value', 'level2_value', 'level3_value', 'level4_value'],
      actionLevels: ['level1'],
      drilldownlevels: [],
      filterValue: '',
      cmnt: "",
      annotations: [],
      annotationTitle: "",
      picked: "",
      selected: {},
      assigned: "",
      section: [],
      userData: {},
      tagTitle: "",
      selectedRows: [],
      isAllSelected: false,
      dudepData: [],
      selectConfigVal: {},
      filter: {},
      filterPl: {},
      listBoxOptions: {},
      listBoxOptionsPl: {},
      listBoxCache: {},
      showTable: false,
      // config:[{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-02","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-03","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-04","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"Expected","level3_value":"2023-05","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Excpected Conversion Month","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Budget","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Residential/ Less Usage","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Customer not occupied","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Customer not available","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Site temporaray closed/ Vacated","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Not Interested","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Project dispute - Outstanding","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Project dispute - technical","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"On Call","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":""},{"level1_value":"NIC","level2_value":"future potential","level3_value":"Rates","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Future Potential","level4_field_name":"Enter Rate","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"dropdown","level4_input_type":"Number Input"},{"level1_value":"NIC","level2_value":"LOST","level3_value":"Lost to OEM","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Lost","level4_field_name":"Enter Name","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"radio","level4_input_type":"Char Input"},{"level1_value":"NIC","level2_value":"LOST","level3_value":"Lost to Local Party","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Lost","level4_field_name":"Enter Name","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"radio","level4_input_type":"Char Input"},{"level1_value":"AMC","level2_value":"Activated against Component No","level3_value":"Component No","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Component No","level4_field_name":"","level1_input_type":"radio","level2_input_type":"dropdown","level3_input_type":"Char Input","level4_input_type":""},{"level1_value":"E Warranty","level2_value":"EWTY given by CAD","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"radio","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"E Warranty","level2_value":"EWTY given by Dealer alone","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"radio","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"Not Handed over","level2_value":"Not yet commissioned/ Handed over","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"checkbox","level3_input_type":"datepicker","level4_input_type":""},{"level1_value":"Not Handed over","level2_value":"Turnkey contractor Not handed over to enduser/ warranty not over","level3_value":"Date","level4_value":"","level1_field_name":"Obligation","level2_field_name":"Status","level3_field_name":"Pick a Date","level4_field_name":"","level1_input_type":"radio","level2_input_type":"checkbox","level3_input_type":"datepicker"}],
      config: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      displayValues: {},
      showAlert: false,
      headerLvl2Display:"",
      headerLvl3Display:"",
      expandedL1: new Set(),  // store expanded rd1l1_name or rd1l1_id
      expandedL2: new Set(),  // store expanded rd1l2_name
      screenTitleInfo:'',
      headerHeight:0,
      hyperlinkConfig:''
    }
  },
  created: function () {
    //this.loadCustomer()
    this.listboxDataFetch();
    this.listenToRouter();
    this.debouncedOptionSelectedPl = debounce(this.applyFilterChanges, 500); // 300ms debounce
    //this.loadConfig()
  },
  mounted() {
    this.headerHeightCal();
  },
  watch: {
    filteredItems(value) {
      // console.log("watch function",value.length,this.rowsdata.length)
      if (value.length < this.rowsdata.length && this.selectedRows.length > 0) {
        this.selectedRows = []
      }
    },
    selectedRows(value) {
      if (value.length === 0) {
        this.isAllSelected = false;
      }
    },
    'selectConfigVal.level1_value'(newVal, oldVal) { //watch level1_value change in group action selection
      // console.log("watch fun select", newVal, oldVal)
      //If level1 selection is changed after selection of underlying levels then reset
      if (newVal !== oldVal && oldVal && Object.keys(this.selectConfigVal).length > 1) {
        this.selectConfigVal = {}
        this.actionLevels = ['level1']
        // this.selectConfigVal['level1_value']=newVal
      }
    },
  },

  computed: {
    gridContainerHeight() {
      const hasBanner = this.$store.state.bannerStatus;

      if (this.headerHeight > 70 && this.headerHeight <190) {
        return hasBanner ?"66.5vh" : "73vh" ;
      } if (this.headerHeight > 190){
        return hasBanner ?"61.5vh" : "67vh" ;
      } else {
        return hasBanner ? "72.5vh" : "79vh";
      }
    },
    filterCount() {
      // eslint-disable-next-line no-unused-vars
      return Object.entries(this.filterPl).filter(([k, v]) => {
        if (Array.isArray(v)) {
          return v.some(val => val != null);  // Only count if there's a valid value
        } else {
          return v != null;  // Only count if non-null and non-undefined
        }
      }).length
    },
    filterIsSelected() {
      return this.filterCount > 0
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      var intmdtColumns = Object.keys(this.rowsdata[0])
      var arr = intmdtColumns.filter(function (item) {
        return item !== "assign" && item !== "user_editable" //to avoid it in displaying in the table
      })
      console.log("arr",arr)
      return arr;
    },
    "R2columns": function columns() {
      if (this.firstDrilldownData.length == 0) {
        return [];
      }
      var intmdt2Columns = Object.keys(this.firstDrilldownData[0])
      var arr2 = intmdt2Columns.filter(function (item) {
        return item !== "assign"
      })
      // console.log("arr2",arr2);
      return arr2;
    },
    "R3columns": function columns() {
      if (this.secondDrilldownData.length == 0) {
        return [];
      }
      var intmdt3Columns = Object.keys(this.secondDrilldownData[0])
      var arr3 = intmdt3Columns.filter(function (item) {
        return item !== "assign"
      })
      return arr3;
    },

    "orderedData": function () {
      let result = this.rowsdata;
      if (this.filterValue) {
        result = result.filter(item => item.rd1.includes(this.filterValue));

      }

      return _.orderBy(result, item => {
        const value = item[this.sortKey];
        const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));
        return isNumeric ? parseFloat(value) : value;
      }, this.sortOrder);

    },
    filteredItems() {
      // console.log("Rows Data Filtered", this.rowsdata)
      let result = this.rowsdata.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {
          if (this.filter[key]) {
            keep =
                keep &&
                (this.filter[key].length == 0 ||
                    this.filter[key].includes(item[key]));
          }
        });

        return keep;
      });
      if (this.filterValue) {
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))
        );

      }

      return _.orderBy(result, item => {
        const value = item[this.sortKey];
        const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));
        return isNumeric ? parseFloat(value) : value;
      }, this.sortOrder);
    },
    filteredConfig() {
      // console.log("action Icons Config ", this.config)
      let result = this.config.filter(item => {
        let keep = true;
        // console.log("Selected Convig", this.selectConfigVal)

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.levelKeys.forEach(key => {
          if (this.selectConfigVal[key]) {
            keep =
                keep &&
                (this.selectConfigVal[key].length == 0 ||
                    this.selectConfigVal[key].includes(item[key]));
          }
        });

        return keep;
      });
      return result;
    },

    actionOptions() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.levelKeys.forEach(key => {
        let vals;
        if (key == 'level1_value') {
          vals = this.config.map(item => item[key]).filter(v => v);
        } else {
          vals = this.filteredConfig.map(item => item[key]).filter(v => v);
        }

        // console.log("Options Data Vals", vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        // console.log("Distinct Options Data ", options[key]);
      });

      return options;
    },

    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]).filter(v => v);
        // console.log("Options Data Vals", vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        // console.log("Distinct Options Data ", options[key]);
      });

      return options;
    },
    hasUserEditableKey() {
      return this.filteredItems.some(item => 'user_editable' in item);
    },
    selectableCount() {
      if (!this.hasUserEditableKey) return null;
      return this.filteredItems.filter(item => item.user_editable !== false).length;
    }


  },

  methods: {
    toggleL1(rowd) {
      const key = this.submenuParam1 === 'G01' ? rowd.rd1l1_id : rowd.rd1l1_name;

      if (this.expandedL1.has(key)) {
        // collapse current row
        this.expandedL1.clear();
        this.firstDrilldownData = [];
        this.secondDrilldownData = [];
        this.whatLA = null;
        this.whatL1 = null;
        this.whatL2 = null;
      } else {
        // collapse others, expand only this
        this.expandedL1.clear();
        this.expandedL1.add(key);
        this.expandedL2.clear(); // reset children
        this.firstDrilldownData = [];
        this.secondDrilldownData = [];
        this.loadLevelData(...[[key]]);
      }
    },

    toggleL2(rowd, first) {
      const key = first.rd1l2_name;
      const val = this.submenuParam1 === 'G01'
          ? [rowd.rd1l1_id, first.rd1l2_name]
          : [rowd.rd1l1_name, first.rd1l2_name];

      if (this.expandedL2.has(key)) {
        // collapse current child
        this.expandedL2.delete(key); // collapse
        this.secondDrilldownData = [];
        // this.whatLA = null;
        this.whatL2 = null;
      } else {
        // collapse others, expand only this
        this.expandedL2.clear();
        this.expandedL2.add(key);
        this.secondDrilldownData = [];
        this.loadLevelData(...[val]);
      }
      // console.log()
    },
    isExpandedL1(rowd) {
      const key = this.submenuParam1 === 'G01' ? rowd.rd1l1_id : rowd.rd1l1_name;
      return this.expandedL1.has(key);
    },
    isExpandedL2(first) {
      return this.expandedL2.has(first.rd1l2_name);
    },
    onAlertDismissed() {
      this.showAlert = false; // Set showAlert to false when dismissed
    },
    showFilterDialog() {
      this.$nextTick(() => {
        this.$refs.dialog.showModal()
      })
    },
    showAlertFunc() {
      this.$nextTick(() => {
        this.showAlert = true;
      })
    },
    hideFilterDialog() {
      this.$refs["dialog"].close()
    },
    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    },
    updateDisplayValue(key, value) {
      this.$set(this.displayValues, key, value);
    },

    processFilterValues(key) {
      const value = this.displayValues[key] || '';
      const values = value.split(',')
          .map(item => item.trim())
          .filter(item => item.length > 0);
      // Limit to first 10 values if more are entered
      const limitedValues = values.slice(0, 10);

      this.$set(this.filterPl, key, limitedValues);

      // Update display to show cleaned version
      this.$set(this.displayValues, key, limitedValues.join(', '));

      // Optionally show a warning if values were truncated
      if (values.length > 10) {
        this.$bvToast.toast('Maximum 10 values allowed. Only the first 10 values will be used.', {
          title: 'Too Many Values Entered',
          variant: 'warning',
          solid: true,
          autoHideDelay: 5000
        });
      }
    },
    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(Jan(uary)?|Feb(ruary)?|Mar(ch)?|Apr(il)?|May|Jun(e)?|Jul(y)?|Aug(ust)?|Sep(tember)?|Oct(ober)?|Nov(ember)?|Dec(ember)?)$/i;

      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        Jan: 0, January: 0,
        Feb: 1, February: 1,
        Mar: 2, March: 2,
        Apr: 3, April: 3,
        May: 4,
        Jun: 5, June: 5,
        Jul: 6, July: 6,
        Aug: 7, August: 7,
        Sep: 8, September: 8,
        Oct: 9, October: 9,
        Nov: 10, November: 10,
        Dec: 11, December: 11
      };

      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    },
    resetActionOptions: function () {
      this.actionLevels = ['level1']
      this.selectConfigVal = {}
      this.iconsConfig = this.drilldowndata.iconsConfig || [{
        "name": "Comment",
        "action_type": "textarea",
        "input_key": "comment"
      }, {
        "name": "Tag",
        "action_type": "radio",
        "input_key": "tag_status",
        "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
      }]
    },
    appendCurLevel: async function (curLevel, input_type, e) {
      if (input_type == 'checkbox') {
        this.selectConfigVal[curLevel + '_value'] = this.selectConfigVal[curLevel + '_value'] || []
        if (e.target.checked) {
          this.selectConfigVal[curLevel + '_value'].push(e.target.value)
        } else {
          this.selectConfigVal[curLevel + '_value'].pop(e.target.value)
        }

      }


      // let key = curLevel+'_value'
      let levelNo = curLevel.replace('level', '') - 1
      let levelPlus = levelNo + 2
      //Push curLevel + 1 only if new level is added
      if (!this.actionLevels.includes('level' + levelPlus)) {
        this.actionLevels.push('level' + levelPlus)
      }

      let levelKeys = this.levelKeys.slice(0, levelNo)
      // console.log("Current Level is ", curLevel, levelNo, levelKeys)
      let result = this.config.filter(item => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        levelKeys.forEach(key => {
          if (this.selectConfigVal[key]) {
            keep =
                keep &&
                (this.selectConfigVal[key].length == 0 ||
                    this.selectConfigVal[key].includes(item[key]));
          }
        });

        return keep;
      });


      let vals = result.map(item => item[curLevel + '_value']).filter(v => v)
      let curLevelOptions = Array.from(new Set(vals)).sort();
      this.actionOptions[curLevel + '_value'] = curLevelOptions
      // console.log("current Level Appending distinct values", result, curLevelOptions, this.actionOptions)
      /*
            this.actionOptions = this.makeListBoxOptions()
                console.log("Current Level ",this.actionOptions,curLevel)
      */

    },
    async optionSelected() {
      this.listBoxOptions = await this.makeListBoxOptions()
      this.showTable = false;
    },
    async optionSelectedPl(filterState) {
      this.debouncedOptionSelectedPl(filterState);
      this.showTable = false;
    },

    async applyFilterChanges(filterState) {
      // console.log("Applying filter changes after debounce:", filterState);
      this.filterPl = {...filterState}; // Ensure filterPl is reactive if mutated
      this.listBoxOptionsPl = await this.makeListBoxOptionsPl();

    },
    submit() {
      this.showTable = true;
    },

    submitPl() {
      if (this.dimSelectDpValuesPl.length > 0) {
        this.whatLA = null;
        this.whatL1 = null;
        this.whatL2 = null;
        this.firstDrilldownData =[];
        this.secondDrilldownData =[];
        this.expandedL1=new Set()
        this.expandedL2=new Set()
        this.loadReportlevel1(this.filterPl)
        this.showTable = true;
      } else {
        this.showTable = true;
      }
      this.$refs["dialog"].close()
    },
    async resetLB() {
      this.filter = Object.fromEntries(
          Object.keys(this.uniqueDimObj[0]).map(k => {
            return [k, []]
          })
      )
      this.listBoxOptions = await this.makeListBoxOptions()
    },
    async resetLBPl() {
      if (this.dimSelectDpValuesPl.length > 0) {
        this.filterPl = Object.fromEntries(
            Object.keys(this.uniqueDimObjPl[0]).map(k => {
              return [k, []]
            })
        )
        this.displayValues = {}
        this.listBoxOptionsPl = await this.makeListBoxOptionsPl()
      } else {
        this.filter = Object.fromEntries(
            Object.keys(this.uniqueDimObj[0]).map(k => {
              return [k, []]
            })
        )
        this.listBoxOptions = await this.makeListBoxOptions()
      }
    },

    async makeListBoxOptions() {
      let listboxData = this.uniqueDimObj
      // console.clear()

      const makeOptions = (records, filterKeys, cacheKey) => {
        //make distinct values of each col
        //total cols = 4

        //cacheKey = simply, length of row + filterKeys

        const getDistinctColValues = () => {

          //for each key, we make a set to hold distinct values
          let localFilters = Object.fromEntries(
              filterKeys.map(k => [k, new Set()])
          )

          //parse through each record
          for (let row of records) {
            //for every filter-key, we add to set, this will de-dup the data
            for (let fk of filterKeys) {
              localFilters[fk].add(row[fk])
            }
          }

          //convert to a map of {k1: [distnct values for k1], k2: [distinct values for k2] .... etc}
          return Object.fromEntries(Object.entries(localFilters).map(x => {
            return [x[0], [...x[1]].sort()]
          }))
        }

        let fromCache = false; //this.listBoxCache[cacheKey]
        //let fromCache = false
        if (cacheKey && fromCache) {
          // console.log(`found from cache ${cacheKey} => ${Object.keys(fromCache).length}`)
          return fromCache;
        } else {
          // let ts = new Date().getTime()
          let value = getDistinctColValues();
          this.listBoxCache[cacheKey] = value;
          // console.log(`set to cache ${cacheKey} => took ${(new Date().getTime() - ts) / 1000}s`)
          // console.log("Initial filter values", value)
          return value;

        }

      }

      const applyNextFilter = (currentFilter, restOfFilters, appliedFilters) => {

        let colSelected = currentFilter[0],
            colValues = currentFilter[1];

        //say 3 filters
        //salesman, brand, store
        //when nothing is selected, then distinct values of each can be used (default)
        //say one is selected, then we use that and select distinct values for rest
        //say two is selected, then use both to select distinct values for rest


        //filter records based on applied filters
        //console.log(`  ApplyFilter, InitialSize = ${listboxData.length}`)
        let listboxdataCopy = [...listboxData]

        for (let restFilter of restOfFilters) {
          // console.log(`  ApplyFilter, RestFilter ${restFilter}`)
          if (restFilter[1].length > 0) {
            listboxdataCopy = listboxdataCopy.filter(x => restFilter[1].indexOf(x[restFilter[0]]) > -1);
          }
          // console.log(`  ApplyFilter, (applied) RestFilter ${restFilter[0]} = ${listboxdataCopy.length}`)
        }

        let optionsAfterRest = makeOptions(
            listboxdataCopy,
            [colSelected],
            [...Object.entries(restOfFilters), currentFilter].map(x => `${x[0]}:${x[1].join('-')}`).join()
        )
        // console.log('optionsAfterRest', optionsAfterRest)

        //select records, by applying the current filter
        let recordsAfterFilter = listboxdataCopy.filter(x => colValues.indexOf(x[colSelected]) > -1);
        // console.log(`  ApplyFilter, CurrentFilter ${colSelected} = ${recordsAfterFilter.length}`)

        //from filters, remove the current filter, and previously applied filters
        let filterRemainingKeys = Object
            .keys(listboxData[0])
            .filter(x => x !== colSelected)
            .filter(x => !appliedFilters.map(y => y[0]).includes(x))

        // console.log(`   ApplyFilter for keys = ${filterRemainingKeys.join(',')}`)
        //now we would have gotten, distinct col values for remaining filter, based on remaining data
        let options = makeOptions(
            recordsAfterFilter,
            filterRemainingKeys,
            Object.entries(this.filter).map(x => `${x[0]}:${x[1].join('-')}`).join()
        )
        // console.log('filterOptions', options)
        return {...options, ...optionsAfterRest}
      }

      if (this.uniqueDimObj.length > 0) {

        //if filter values are selected, then apply
        let initialFilterValues = makeOptions(listboxData, Object.keys(listboxData[0]), "ALL")
        let nextFilter = null;
        //iterate through each filter
        let filterEntries = Object.entries(this.filter);
        let appliedFilters = []
        for (let currFilter of filterEntries) {

          let restOfFilters = filterEntries.filter(x => x[0] !== currFilter[0])

          //if the filter is selected
          if (currFilter[1].length > 0) {

            let prevFilter = {...(nextFilter || initialFilterValues)}
            // console.log('apply currFilter', currFilter, 'prevFilter', prevFilter)
            let appliedFilter = applyNextFilter(
                currFilter,
                restOfFilters,
                appliedFilters
            )
            // console.log('applied currFilter', currFilter, appliedFilter)
            appliedFilters.push(currFilter)

            nextFilter = {...prevFilter, ...appliedFilter}
          }

          //else, skip this filter
        }
        return nextFilter || initialFilterValues

      } else {
        return {}

      }
    },
    async makeListBoxOptionsPl() {
      const records = this.uniqueDimObjPl;
      const filterPl = this.filterPl; // Cache this reference

      if (records.length === 0) {
        return {};
      }

      // --- Helper to get distinct values from a dataset for specified keys ---
      const getDistinctValuesForKeys = (data, keysToExtract) => {
        const distinctValues = {};
        for (const key of keysToExtract) {
          distinctValues[key] = new Set();
        }

        for (const row of data) {
          for (const key of keysToExtract) {
            if (row[key] !== undefined && row[key] !== null) {
              distinctValues[key].add(row[key]);
            }
          }
        }

        const result = {};
        for (const key in distinctValues) {
          result[key] = [...distinctValues[key]].sort();
        }
        return result;
      };

      // --- Helper to filter records based on provided filters ---
      const filterRecords = (data, filters) => {
        // Build lookup sets for filters for O(1) average lookup
        const filterLookups = {};
        let hasFilters = false;
        for (const [key, values] of Object.entries(filters)) {
          if (values && values.length > 0) {
            filterLookups[key] = new Set(values);
            hasFilters = true;
          }
        }

        if (!hasFilters) {
          return data; // No active filters, return original data
        }

        return data.filter(row => {
          for (const key in filterLookups) {
            if (!filterLookups[key].has(row[key])) {
              return false; // Row does not match filter for this key
            }
          }
          return true; // Row matches all applied filters
        });
      };

      // --- Main Logic ---

      // Get all unique keys from the first record (assuming consistent schema)
      const allDataKeys = records.length > 0 ? Object.keys(records[0]) : [];
      const finalListBoxOptions = {}; // This will hold the final options for all dropdowns

      // Iterate through each possible filter key (all columns in your data)
      for (const currentKey of allDataKeys) {
        // Create a set of filters excluding the current key being processed
        const filtersForOthers = {};
        for (const [filterKey, filterValues] of Object.entries(filterPl)) {
          if (filterKey !== currentKey && filterValues && filterValues.length > 0) {
            filtersForOthers[filterKey] = filterValues;
          }
        }

        // 1. Filter the entire dataset based on ALL *OTHER* active filters
        const filteredByOthers = filterRecords(records, filtersForOthers);

        // 2. Get distinct values for the `currentKey` from this *reduced* dataset
        // These are the values "available" for selection in the current dropdown,
        // given what's selected in other dropdowns.
        const availableOptionsForCurrentKey = getDistinctValuesForKeys(filteredByOthers, [currentKey])[currentKey] || [];

        // 3. Get the values already selected in the current dropdown
        const currentlySelectedForCurrentKey = filterPl[currentKey] || [];

        // 4. Combine available options with currently selected options
        // This ensures that chosen items remain visible, and new valid options are added.
        const combinedSet = new Set([
          ...availableOptionsForCurrentKey,
          ...currentlySelectedForCurrentKey
        ]);

        // Store the sorted combined options for the current dropdown
        finalListBoxOptions[currentKey] = [...combinedSet].sort();
      }

      // console.log("Final Listbox Options (Corrected):", finalListBoxOptions);
      return finalListBoxOptions;
    },
    sortBy: function (key) {
      // console.log("The sort Key is ", key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey = key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    getClass(a) {
      if (a == 'Level3') {
        //this.class="first"
        return 'third'
      }
      if (a == 'Level2') {
        //this.class = "second"
        return 'second'
      }
      if (a == 'Level1') {
        //this.class = "third"
        return 'first'
      }
    },
    selectAll() {
      this.selectedRows = [];

      if (!this.isAllSelected) {
        this.filteredItems.forEach(row => {
          if (row.user_editable !== false) { //allow only editable records
            this.selectedRows.push(row.rd1l1_name);
          }
        });
      }
      this.isAllSelected = !this.isAllSelected;
    },
    /* downloadFile: function (file_name) {
             console.log(file_name, 'is the name')
       axios.get(`/api/file_exists_processed?fileName=${file_name}`)
           .then(function (resp) {
             if (resp.data.exists) {
               console.log(file_name, 'is the name2')

               return `http://localhost:9888/${file_name}`
              // return `http://139.59.58.160:9888/${file_name}`
             } else {
              alert("File does not Exists")
             }
           }, function () {
             alert('Error in checking file present status');
           })
       },*/
    handleActionIconFunctionCall(fnName, index, x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      // console.log("Handle function called with func name", fnName, this.iconOnChangeFlag, x)
      this[fnName](x)
    },
    downloadFile: function (fileId) {
      let file = this.rowsdata.filter(item => item.rd1l1_name == fileId)
      var fileName = this.rowsdata.filter(item => item.rd1l1_name == fileId)[0].rd1l3_name
      if (file[0].rd1l6_name == 'success') {
        fileName = 'processed/' + fileName
      } else if (file[0].rd1l6_name == 'error') {
        fileName = 'error_file/' + fileName
      } else if (file[0].rd1l6_name == 'Unprocessed') {
        fileName = 'landing/' + fileName
      }
      // console.log(fileName, 'is the file name of ', fileId, file, fileName)
      // window.location= `http://localhost:9888/${fileName}`
      window.location = `http://139.59.58.160:9888/${fileName}`
    },

    loadDudep: function () {
      let url = '/api/dedup-get'
      axios.get(url)
          .then(res => {
            this.dudepData = res.data
            // console.log("ALl dedup data", this.dudepData)
          }, err => {
            console.error('Error in fetching record', err)
          })
    },
    //Put/Update Request
    accept: function (x) {
      this.$refs["accept-box"].show();
      if (x) {
        // console.log('Testing update request', x)
        axios.post('/api/dedup-update/' + x + '/Accept')
            .then(response => {
              // this.loadDudep()
              this.loadReportlevel1()
              console.log('Data Updated successfully', response)
            })
            .then(this.loadDudep(), e => {
              console.error('error in Updating Record', e)
            })
      }
    },
    reject: function (x) {
      this.$refs["reject-box"].show();
      if (x) {
        axios.post('/api/dedup-update/' + x + '/Reject')
            .then(response => {
              // this.loadDudep()
              this.loadReportlevel1()
              console.log('Data Updated successfully', response)
            })
            .then(this.loadDudep(), e => {
              console.error('error in Updating Record', e)
            })
      }
    },
    assignBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      // console.log(
      //     `ENTERED into the assignBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Assignment";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + (this.section.length > 3 ? this.section.length + ' rows selected' : this.section);
      if (this.section.length > 0 && this.section.length < 500) this.$refs["assign-box"].show();
      else this.$refs["error-box"].show()
      this.assigned = this.$store.state.firstName //default to self
      // axios.get("/api/user").then(res => {
      //       this.userData = res.data
      //     },
      //     err => {
      //       console.log('Error Fetching data', err)
      //     })
    },
    postAssign: async function () {
      this.spinner = true
      // console.log("spinner after update", this.spinner, new Date(), this.rowsdata.filter(f => f.assign))
      let selected = []
      this.iconsConfig.tagList.filter(f => {
        if (f.value) {
          // console.log("data from assign filter", f.tag_list)
          selected.push(f.tag_list)
          return f.tag_list;
        }
      })
      // console.log("Data from Assign box", this.picked, this.selected, this.assigned, this.cmnt)
      let tagStatus = this.selected.length > 0 ? this.selected.toString() : selected.length > 0 ? selected.toString() : ''
      // console.log("Data from assign box", tagStatus, this.selectConfigVal)
      // tagStatus= tagStatus + ',' + this.iconsConfig
      const url = "/api/businessActions";
      let actionValues = {}
      this.iconsConfig.forEach(ic => {
        // console.log("action input ic value", ic)
        if (ic.action_type === 'checkbox') {
          let selected = []
          ic.tagList.filter(f => {
            // console.log("ACTION INPUT data from assign filter", f.tag_list)
            if (f.value) selected.push(f.tag_list)
          })
          actionValues[ic.input_key] = selected.toString() //to convert array values as comma separated string
        } else if (ic.is_group_action != 'yes') {
          actionValues[ic.input_key] = ic.value ? ic.value.toString() : ''
        }

      })
      //Remove Last Key item to filter the config to obtain the Field names to map
      let popLastItem = _.clone(this.selectConfigVal)
      let keys = Object.keys(this.selectConfigVal)
      delete popLastItem[keys[keys.length - 1]]

      // console.log("Popped Config", popLastItem, this.selectConfigVal)

      let filteredConfig = this.config.filter(item => {
        let keep = true;
        // console.log("Selected Config", this.selectConfigVal)
        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.levelKeys.forEach(key => {
          if (popLastItem[key]) {
            keep =
                keep &&
                (this.selectConfigVal[key].length == 0 ||
                    this.selectConfigVal[key].includes(item[key]));
          }
        });

        return keep;
      });


      // console.log("Action Input values", actionValues, filteredConfig)
      let groupConfigVal = {}
      Object.keys(this.selectConfigVal).forEach(lk => {
        let key = lk.replace('_value', '')
        let singleConfig = filteredConfig[0]
        let inputFieldName = singleConfig[key + '_field_name']
        groupConfigVal[inputFieldName] = this.selectConfigVal[key + '_value'].toString() //to convert array values as comma separated string
        // console.log("Action Select Group Config Values", lk, singleConfig, inputFieldName)
      })
      // console.log("Action Select Group Config Values", groupConfigVal)
      let mergedActionValues = {...actionValues, ...groupConfigVal}
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        menuId: this.$route.params.submenuId,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        tagStatus: this.picked || tagStatus,
        assignedTo: this.assigned,
        bizInputValues: mergedActionValues
      };
      let menuParam = this.$route.params.submenuId
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      // console.log("menuDetails", menuDetails);
      const controller = apiAbort.new();
      axios.post(url, data,{
        signal: controller.signal
      }).then(
          () => {
            this.$store.dispatch("loadAnnotations");
            /*            this.rowsdata.filter(f => f.rd1l1_name == this.section)
                        const index = this.rowsdata.findIndex(obj => {
                          return obj.rd1l1_name === this.section;
                        });
                        console.log(index); //

                        this.rowsdata[index].assign = this.assigned;*/

            //Get Request
            axios.post('/api/reportConfigColumn/' + this.$route.params.submenuId, this.filterPl, {
              signal: controller.signal,
              headers: {
                'info-params': JSON.stringify({
                  menuId: this.$route.params.menuId,
                  submenuId: this.$route.params.submenuId
                }),
                'Content-Type': 'application/json'
              }
            })
                //      axios.get('/api/reportConfigColumn/'+ menuParam + '/' +submenuParam)
                .then(res => {
                  this.drilldowndata = res.data
                  /*
                      this.reportDataConfig = this.drilldowndata
                      console.log("REport PAge DATA config", this.reportDataConfig)
                      this.repTitle = this.drilldowndata.columns[0].reportName
                      this.columns = this.drilldowndata.columns
*/
                  this.rowsdata = this.drilldowndata.rowsData
                  // this.icons = this.drilldowndata.icons

                  //to reset the previously entered values
                  this.iconsConfig = this.drilldowndata.iconsConfig || [{
                    "name": "Comment",
                    "action_type": "textarea",
                    "input_key": "comment"
                  }, {
                    "name": "Tag",
                    "action_type": "radio",
                    "input_key": "tag_status",
                    "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
                  }]
                  this.config = this.iconsConfig.filter(ic => ic.is_group_action == 'yes').length > 0 ? this.iconsConfig.filter(ic => ic.is_group_action == 'yes')[0].tagList : []
                  this.iconsConfig["tagList"] = this.drilldowndata.tagList || [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
                  this.spinner = false
                  this.selectedRows = []; //reset the rows selection
                  this.selectConfigVal = {} //reset the Group action input values
                  // console.log("spinner after update", this.spinner, new Date(), this.rowsdata.filter(f => f.assign))
                }).catch(e=>{
                    console.error("error",e);
                })
            this.$commonFn.auditLog(menuDetails[0]?.syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "POST", "Success",this.$store.state.deviceType)
          },
          (e) => {
            //to reset the previously entered values
            this.iconsConfig = this.drilldowndata.iconsConfig || [{
              "name": "Comment",
              "action_type": "textarea",
              "input_key": "comment"
            }, {
              "name": "Tag",
              "action_type": "radio",
              "input_key": "tag_status",
              "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
            }]
            this.config = this.iconsConfig.filter(ic => ic.is_group_action == 'yes').length > 0 ? this.iconsConfig.filter(ic => ic.is_group_action == 'yes')[0].tagList : []
            this.iconsConfig["tagList"] = this.drilldowndata.tagList || [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
            this.spinner = false
            this.selectedRows = []; //reset the rows selection
            this.selectConfigVal = {} //reset the Group action input values
            // console.log("Post annotation", data)
            // console.log("Audit log", menu, subMenu, e)
            this.$commonFn.auditLog(menuDetails[0]?.syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName,"POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      // let menu = this.pg;
      // let subMenu = this.section;
      // console.log("Audit log", menu, subMenu)
      // console.log("the menus and submenus for Audit log is", menu, subMenu);
      // await this.loadReportlevel1();
      // console.log("spinner value",this.spinner, new Date())
      // await this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },
    tagBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      // console.log(
      //     `ENTERED into the tagBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.tagHeader = "User Tagging";
      this.tagTitle =
          this.tagHeader + "->" + this.pg + "->" + this.section;
      this.$refs["tag-box"].show();
    },
    postTagging: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
        tagStatus: this.picked,
      };
      let menuParam = this.$route.params.submenuId
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      // console.log("menuDetails", menuDetails);
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
            this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "POST", "Success",this.$store.state.deviceType)
          },
          (e) => {
            this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName,"POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      // let menu = this.pg;
      // let subMenu = this.section;
      // console.log("the menus and submenus for Audit log is", menu, subMenu);

      // this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },
    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      // console.log(
      //     `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      // );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      let menuParam = this.$route.params.submenuId
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      // console.log("menuDetails", menuDetails);
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
            this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "POST", "Success",this.$store.state.deviceType)
          },
          (e) => {
            this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName,"POST", e,this.$store.state.deviceType);
            console.error("error in updating annotations", e);
          }
      );
      // let menu = this.pg;
      // let subMenu = this.section;
      // console.log("the menus and submenus for Audit log is", menu, subMenu);
      // this.loadReportlevel1()

    },

    loadLevelData: function (l1A) {

      var l1 = l1A[0]
      var l2 = l1A[1]
      // console.log('Level 1 Data', l1A)
      // var array1 = [...Array(5)]
      // console.log("Array", Object.getOwnPropertyNames(array1))
      // console.log("this.whatLA",_.isEqual(this.whatLA, l1A),this.whatLA)
      // if (_.isEqual(this.whatLA, l1A)) {
      //   this.whatLA = null
      //   this.whatL1 = null
      //   this.whatL2 = null
      // } else {
        this.whatLA = [...l1A]
        this.whatL1 = l1
        this.whatL2 = l2
        //Post Request
        var LPA = []
        var arrayleng = l1A.length
        LPA.push(this.$route.params.menuId)
        LPA.push(this.$route.params.submenuId)
        LPA.push('level' + ++arrayleng)
        LPA.push(...l1A)
        // console.log("NEW LEVEL PARAM ARRAY", LPA, (l1A.length)++)
        const requestData = {
          LPA: LPA,
          filterPl: this.filterPl
        };
        // console.log("request data",requestData);
        const controller = apiAbort.new()
        axios.post('/api/repLevelData', requestData,{signal:controller.signal})
            .then(res => {
              if (arrayleng == 2) {
                this.firstDrilldownData = res.data
                // console.log("Post API Called", this.firstDrilldownData)
              } else if (arrayleng == 3) {
                this.secondDrilldownData = res.data
                // console.log('Second DrillDown Data Are', this.secondDrilldownData)

              }
            }).catch(e=>{
                console.log("error",e);
            })
        // console.log("Outside if cond POst API", this.firstDrilldownData)
        // console.log("Outside if cond POst API", this.secondDrilldownData)

      // }

    },

    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        apiAbort.cancel()
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns = []
        $this.section = ''
        $this.dimSelectDpValues = []
        $this.dimSelectDpValuesPl = [],
            $this.dimInputDpValuesPl = [],
            $this.filter = {}
        $this.filterPl = {}
        $this.listBoxOptions = []
        $this.listBoxOptionsPl = []
        $this.showTable = false
        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresDrilldownConfig)) {
            // console.log("inside if condition")
            $this.listboxDataFetch();
          }
        }, 300)

      })
    },

    headerHeightCal() {
      const headerEl = this.$el.querySelector(".card-body-header");
      if (headerEl) {
        // Create observer
        this.headerObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            this.headerHeight = entry.contentRect.height;
            // console.log("Card header height:", this.headerHeight);
          }
        });
        this.headerObserver.observe(headerEl);
      }
    },

    listboxDataFetch: async function () {
      let menuParam = this.$route.params.submenuId
      // console.log("menuParam", menuParam);
      const controller = apiAbort.new();
      axios.get('/api/fetchReportListboxData/' + menuParam, {
        signal : controller.signal,
        headers: {
          'info-params': JSON.stringify({
            menuId: this.$route.params.menuId,
            submenuId: this.$route.params.submenuId
          }),
          'Content-Type': 'application/json'
        }
      }).then(async res => {
        // console.log("Listbox Config Data", res.data)
        let lbConfig = res.data.lbConfig
        let lbData = res.data.lbData
        if (lbConfig != null) {
          let lbColMap = lbConfig.listbox_col_map
          let lbInpMap = lbConfig.filter_inp_col_map || {}
          this.dimSelectDpValuesPl = Object.keys(lbColMap)
          this.dimInputDpValuesPl = Object.keys(lbInpMap)
          this.rowsDataDimKeysPl = Object.values(lbColMap)
          this.rowsDataDimKeysInpPl = Object.values(lbInpMap);
          this.repTitle = lbConfig.report_name || ""
          this.headerLvl2Display = lbConfig.header_lvl2_display || "";
          this.headerLvl3Display = lbConfig.header_lvl3_display || "";
          this.hyperlinkConfig = lbConfig.hyperlink_config || 'click here';

          /*const removeEmptyOrNull = (obj) => {
            Object.keys(obj).forEach(k =>
                (obj[k] && typeof obj[k] === 'object') && removeEmptyOrNull(obj[k]) ||
                (!obj[k] && obj[k] !== undefined) && delete obj[k]
            );
            return obj;
          };*/
          this.uniqueDimObjPl = lbData
          this.listBoxOptionsPl = await this.makeListBoxOptionsPl()
          // Sorting date-related objects
          for (const key in this.listBoxOptionsPl) {
            const values = this.listBoxOptionsPl[key];
            // console.log("values", values);
            if (Array.isArray(values)) {
              // Sort date-related values in descending order
              this.listBoxOptionsPl[key] = values.sort((a, b) => {
                if (!this.isDateRelated(a) || !this.isDateRelated(b)) return 0;
                const monthPattern = /^(Jan(uary)?|Feb(ruary)?|Mar(ch)?|Apr(il)?|May|Jun(e)?|Jul(y)?|Aug(ust)?|Sep(tember)?|Oct(ober)?|Nov(ember)?|Dec(ember)?)$/i;

                // Special case: Month names
                if (monthPattern.test(a) && monthPattern.test(b)) {
                  const monthOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  return monthOrder.indexOf(a.slice(0, 3)) - monthOrder.indexOf(b.slice(0, 3));
                }
                return this.parseDate(b) - this.parseDate(a)
              });
            }
          }
          // console.log(" this.listBoxOptionsPl", JSON.stringify(this.listBoxOptionsPl));
          // console.log("Listbox Config", lbData)
        }
        this.screenTitleInfo = res.data.screenTitleInfo
      }).catch(e=>{
        console.error("error",e);
      })
      if (this.$store.state.deviceType === 'Mobile') {
        this.showAlertFunc();
        // console.log("show alert", this.showAlert);
        this.showFilterDialog();
      }
      // const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
      // console.log("menuDetails", menuDetails);
      // await this.$commonFn.auditLog(menuDetails[0].syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success")
    },

    loadReportlevel1: async function (filterParam) {
      let menuParam = this.$route.params.submenuId
      let submenuParam = this.$route.params.submenuId
      // console.log('ddrn2', 'loading state', filterParam);
      this.$store.dispatch("loadState").then(() => {

        let actionIconsData = this.$store.state.actionIcons
        // console.log("actions:", actionIconsData)

        this.submenuParam1 = submenuParam
        this.funCallParamArr = ['True', Array('True', 'rowd.rd1l1_id'), Array('True', 'rowd.rd1l1_id', 'rowd.rd1l2_name')]
        this.clickSymbolArr = ['+', '&gt;&gt;', '&#8680;']

        //Get Listbox Data if null derive from report data

        /*let filterParam = {}
        if(Object.entries(this.filterPl).length>0){
          filterParam = this.filterPl
        }*/
        if (filterParam == undefined) {
          filterParam = {}
        }
        // console.log("Report Called with Param", filterParam)
        const controller = apiAbort.new();

        //Get Request
        axios.post('/api/reportConfigColumn/' + menuParam, filterParam, {
          signal : controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        })
            //      axios.get('/api/reportConfigColumn/'+ menuParam + '/' +submenuParam)
            .then(async res => {
              this.drilldowndata = res.data
              this.reportDataConfig = this.drilldowndata
              // console.log("REport PAge DATA config", this.reportDataConfig)
              this.repTitle = this.drilldowndata.columns[0].reportName
              this.screenTitleInfo = this.drilldowndata.columns[0].screenTitleInfo
              // console.log("data check:",this.drilldowndata)
              this.columns = this.drilldowndata.columns
              this.rowsdata = this.drilldowndata.rowsData
              this.icons = this.drilldowndata.icons


              // let dbIconsConfig={"actions":[{"name":"Obligation","level":1,"is_group_action":"yes","action_type":"radio","input_key":"obligation","group_input_list_sql":"select unnest(string_to_array('OnTrack,RedFlag,Validate',',')) as tag_list","group_action":[{"name":"Status","level":2,"action_type":"checkbox","input_key":"status","input_list_sql":"select unnest(string_to_array('WTY,Active,Not Active',',')) as tag_list"},{"name":"Extended warranty","level":3,"action_type":"datepicker","input_key":"date for extended warranty"},{"name":"Expected conversion month","action_type":"dropdown","level":4,"input_key":"expected conversion month","input_list_sql":"select unnest(string_to_array('202312,202401,202403',',')) as tag_list"}]},{"name":"Comment","action_type":"textarea","input_key":"comment"},{"name":"Assign","action_type":"dropdown","input_key":"assign","input_list_sql":"fw_core_config_conn select user_short_name as tag_list from fw_core.fw_m_user where client_id=10 and function_id=1"},{"name":"Additional","action_type":"text"}]}
              this.iconsConfig = this.drilldowndata.iconsConfig || [{
                "name": "Comment",
                "action_type": "textarea",
                "input_key": "comment"
              }, {
                "name": "Tag",
                "action_type": "radio",
                "input_key": "tag_status",
                "tagList": [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
              }]
              // this.iconsConfig=dbIconsConfig.actions
              this.config = this.iconsConfig.filter(ic => ic.is_group_action == 'yes').length > 0 ? this.iconsConfig.filter(ic => ic.is_group_action == 'yes')[0].tagList : []

              this.iconsConfig["tagList"] = this.drilldowndata.tagList || [{"tag_list": "OnTrack"}, {"tag_list": " RedFlag"}, {"tag_list": " Validate"}]
              this.cleanedDownload = this.drilldowndata.downloadRowsData
              this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_${this.repTitle}.csv`
              // console.log("API Response", this.config, this.drilldowndata, this.icons, this.iconsConfig, this.iconsConfig['tagList'].map(k => k['tag_list']))
              this.drilldownlevels = [...new Set(this.columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
              this.levels = 1

              //Rep level action icons
              let repIcons = this.icons.filter(indi => indi.drilldownLevel == 'level1') // get only level1 for report level icons
              // console.log('Rep Icons:', this.repIcons)
              var repActionIconsSyspkArray = repIcons[0].repActionIconsSyspkArray ? repIcons[0].repActionIconsSyspkArray : []
              // console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0].repActionIconsSyspkArray)
              this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
              // console.log('Rep Action icons:', repActionIconsSyspkArray)

              for (var i = 1; i <= this.drilldownlevels.length; i++) {
                var value = 'level' + i
                this.levelColumns[i] = this.columns.filter(ind => ind.drilldownLevel == value && ind.headerColumnDisplay != 'checkbox')
                this.checkboxFlag[i] = this.columns.filter(ind => ind.drilldownLevel == value && ind.headerColumnDisplay == 'checkbox').length > 0 ? true : false
                this.headerColumns[i] = this.levelColumns[i].map(function (el) {
                  return el.headerColumnDisplay;
                })
                this.levelicons[i] = this.icons.filter(indi => indi.drilldownLevel == value)

                // console.log('WC1:', this.icons, this.columns)

                var vizletActionIconsSyspkArray = this.levelicons[i][0].actionIconsSyspkArray ? this.levelicons[i][0].actionIconsSyspkArray : []
                // console.log('WC2:', vizletActionIconsSyspkArray, this.levelicons[i][0].actionIconsSyspkArray)

                this.currentMenuActionIconsData[i] = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk))
                //   console.log('WC:',vizletActionIconsSyspkArray,this.currentMenuActionIconsData,this.drilldowndata.icons)

                this.currentMenuActionIconsData[i].sort(sortFuncAI); //sorting the currentMenuActionIconsData
                // console.log("actions1:", this.currentMenuActionIconsData[i], actionIconsData)
                this.iconOnChangeFlag[i] = Array(this.currentMenuActionIconsData[i].length).fill(true);


              }

              function sortFuncAI(a, b) {
                //    console.log("test sort ", a,b)
                return vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
              }

              //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
              // console.log("Drilldown data level1", this.headerColumns[1])
              // console.log("Drilldown data level2", this.headerColumns[2])
              // console.log("Drilldown data level3", this.headerColumns[3])
              // console.log("Function Call PAram ", this.funCallParamArr)
              // console.log("Clickable Symbol", this.clickSymbolArr)
              var rowsDataKeys = Object.keys(this.rowsdata[0])

              function createObject(keys, values) {
                const obj = Object.fromEntries(
                    keys.map((key, index) => [key, values[index]]),
                );

                return obj;
              }

              this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
              this.dimSelectDpValues = this.headerColumns[1].slice(0, this.rowsDataDimKeys.length)
              let dimSelectObj = createObject(this.headerColumns[1], rowsDataKeys)
              let dimRowsData = this.rowsdata.map(rd => _.pick(rd, this.rowsDataDimKeys))


// we pass a comparator function that compares objects a & b
              this.uniqueDimObj = _.uniqWith(dimRowsData, (a, b) => {
                // we use _.isEqual to compare if a & b have exactly the same values for all the properties
                return _.isEqual(a, b)
              });

              this.dimSelectDpValues = []
              Object.entries(dimSelectObj).filter(([key, value]) => {
                if (this.rowsDataDimKeys.includes(value)) {
                  // console.log("dimension key and value", key, value)
                  this.dimSelectDpValues.push(key)
                }
              })
              // console.log('Dimension variables Keys', dimSelectObj, this.rowsDataDimKeys)
              // console.log('Dimension variables Keys', this.dimSelectDpValues, dimRowsData, this.uniqueDimObj)

              this.level1Columns = this.headerColumns[1]
              this.level2Columns = this.headerColumns[2]
              this.level3Columns = this.headerColumns[3]

              const removeEmptyOrNull = (obj) => {
                Object.keys(obj).forEach(k =>
                    (obj[k] && typeof obj[k] === 'object') && removeEmptyOrNull(obj[k]) ||
                    (!obj[k] && obj[k] !== undefined) && delete obj[k]
                );
                return obj;
              };

              this.uniqueDimObj = removeEmptyOrNull(this.uniqueDimObj) //removes the null and empty values in the resultset
              //convert set of values into an array using array.from
              //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
              //return temp
              this.filter = Object.fromEntries(
                  Object.keys(this.uniqueDimObj[0]).map(k => {
                    return [k, []]
                  })
              )
              this.listBoxOptions = await this.makeListBoxOptions()
              // let currentMenu = this.$store.state.menuMasterFlat.filter(f => f.menuId === menuParam)
              // console.log("Audit log", menuParam, this.$route.params.menuId, currentMenu[0])
              // this.$commonFn.auditLog(9999,menuParam, menuParam, "Drilldown-report", "POST", );
              // menusyspk, menuid, menuname, vizunit, action, response

            }).catch(e=>{
              console.error("error",e);
            })
        const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam)
        // console.log("menuDetails", menuDetails);
        this.$commonFn.auditLog(menuDetails[0]?.syspk, menuParam, menuDetails[0].menuName, menuDetails[0].menuName, "GET", "Success",this.$store.state.deviceType)
      })
    }
  }
}

</script>
<style>
.first {
  color: #ffa500
}

.second {
  color: #EE4B2B
}

.third {
  color: #8B0000
}

.grid-container {
  overflow: auto;
}


.grid-col--fixed-left {
  position: sticky;
  left: 0;
  /*z-index: 9998;*/
  background: white;

  outline: 2px solid #e4e7ea;
}

.grid-item--header-one {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}

.blue-placeholder::placeholder {
  color: #A1CCFF;
  opacity: 1; /* Firefox reduces opacity by default */
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black
}

.my-custom-tooltip {
  background-color: transparent !important; /* Semi-transparent background */
  padding: 15px !important; /* Increased padding for better spacing */
  border: none !important;
  box-shadow: none !important; /* Subtle shadow for depth */
}

.my-custom-tooltip .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1200px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}

dialog {
  width: 66vw;
  height: 66vh;
  margin: auto;
  border: 0 none;
  border-radius: 10px;
  padding: 2em;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 20%);
}

.row {
  margin: 2px;
}

.card-section {
  width: 100%
}

.banner-true {
  height: 86vh;
}

.banner-false {
  height: 93vh;
}

.card-body {
  padding: 1px;
}

.disabled-checkbox {
  background-color: #f2dede; /* light red */
  cursor: not-allowed;
  border-radius: 4px;
}

</style>